import { useState, useEffect } from 'react';
import axios from 'axios';
import { Insight } from '../InsightCard';

export interface PortfolioInsights {
  portfolioScore: number;
  alignment: number;
  insights: Insight[];
}

export const usePortfolioInsights = () => {
  const [data, setData] = useState<PortfolioInsights | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    axios.get('/api/portfolio/insights')
      .then((res) => {
        setData(res.data);
        setError(null);
      })
      .catch((err) => {
        setError('Erreur lors du chargement des insights');
        setData(null);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading, error };
};
